import "core-js/modules/es.array.concat";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.split";
import "core-js/modules/es.string.starts-with";
import "core-js/modules/es.string.trim";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _createForOfIteratorHelper from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import util from "@/libs/util";
var BASE_URL = process.env.VUE_APP_CHAT;
console.log("BASE_URL===", BASE_URL); //https://data-analysis-helper.colocess.com
//https://data-analysis-helper-test.colocess.com

var getHeaders = function getHeaders() {
  var token = util.cookies.get("token"); // 或者从 Vuex 中获取

  return {
    'Content-Type': 'application/json',
    'Authorization': token ? "Bearer ".concat(token) : ''
  };
};

export var chatApi = {
  // 1. 创建线程
  createThread: function createThread(data) {
    return fetch("".concat(BASE_URL, "/api/threads"), {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify({
        products: data
      })
    }).then(function (res) {
      return res.json();
    });
  },
  // 2. 发送消息（核心：处理 SSE 流）
  sendMessage: function sendMessage(threadId, content, onMessage, signal) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var response, reader, decoder, buffer, currentEvent, _yield$reader$read, done, value, lines, _iterator, _step, line, trimmedLine, jsonStr, parsedData, callbackData;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return fetch("".concat(BASE_URL, "/api/threads/").concat(threadId, "/messages"), {
                method: 'POST',
                headers: getHeaders(),
                body: JSON.stringify({
                  message: content
                }),
                signal: signal
              });

            case 2:
              response = _context.sent;
              console.log("response==", response);
              reader = response.body.getReader();
              decoder = new TextDecoder();
              buffer = '';
              currentEvent = '';
              _context.prev = 8;

            case 9:
              if (!true) {
                _context.next = 45;
                break;
              }

              if (!(signal && signal.aborted)) {
                _context.next = 14;
                break;
              }

              _context.next = 13;
              return reader.cancel();

            case 13:
              return _context.abrupt("break", 45);

            case 14:
              _context.next = 16;
              return reader.read();

            case 16:
              _yield$reader$read = _context.sent;
              done = _yield$reader$read.done;
              value = _yield$reader$read.value;

              if (!done) {
                _context.next = 21;
                break;
              }

              return _context.abrupt("break", 45);

            case 21:
              buffer += decoder.decode(value, {
                stream: true
              });
              lines = buffer.split('\n');
              buffer = lines.pop();
              _iterator = _createForOfIteratorHelper(lines);
              _context.prev = 25;

              _iterator.s();

            case 27:
              if ((_step = _iterator.n()).done) {
                _context.next = 35;
                break;
              }

              line = _step.value;
              trimmedLine = line.trim();

              if (trimmedLine) {
                _context.next = 32;
                break;
              }

              return _context.abrupt("continue", 33);

            case 32:
              // 1. 如果是 event 类型
              if (trimmedLine.startsWith('event: ')) {
                currentEvent = trimmedLine.replace('event: ', '');
              } // 2. 如果是 data 类型，解析并合并
              else if (trimmedLine.startsWith('data: ')) {
                  jsonStr = trimmedLine.replace('data: ', '');

                  try {
                    parsedData = JSON.parse(jsonStr); // 将 event 类型注入到数据对象中

                    callbackData = _objectSpread({
                      event: currentEvent
                    }, parsedData);
                    onMessage(callbackData);
                  } catch (e) {
                    console.error("JSON 解析错误:", jsonStr);
                  }
                }

            case 33:
              _context.next = 27;
              break;

            case 35:
              _context.next = 40;
              break;

            case 37:
              _context.prev = 37;
              _context.t0 = _context["catch"](25);

              _iterator.e(_context.t0);

            case 40:
              _context.prev = 40;

              _iterator.f();

              return _context.finish(40);

            case 43:
              _context.next = 9;
              break;

            case 45:
              _context.next = 54;
              break;

            case 47:
              _context.prev = 47;
              _context.t1 = _context["catch"](8);

              if (!(_context.t1.name === 'AbortError')) {
                _context.next = 53;
                break;
              }

              console.log('读取流时捕获到中断');
              _context.next = 54;
              break;

            case 53:
              throw _context.t1;

            case 54:
              _context.prev = 54;
              reader.releaseLock(); // 释放锁

              return _context.finish(54);

            case 57:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[8, 47, 54, 57], [25, 37, 40, 43]]);
    }))();
  }
};